import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * A redux-form switch laid out as a settings row: label (and an optional
 * description) on the left, the switch on the right. Uses the same switch
 * styles as Switch.jsx; clicking the label toggles it too.
 */
const SwitchRow = ({ input, label, description, disabled }) => (
  <div className={classNames('switch-row', { disabled })}>
    <label className="switch-row__text" htmlFor={input.name}>
      <span className="switch-row__label">{label}</span>
      {description && (
        <span className="switch-row__description">{description}</span>
      )}
    </label>
    <div className={classNames('switch-btn', { disabled })}>
      <label
        className={classNames('switch-btn--container', {
          active: !!input.value,
        })}
      >
        <input
          className="switch-btn--input"
          type="checkbox"
          id={input.name}
          name={input.name}
          onChange={input.onChange}
          checked={!!input.value}
          disabled={disabled}
        />
        <span className="switch-btn--button" />
      </label>
    </div>
  </div>
);

SwitchRow.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }).isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool,
};

SwitchRow.defaultProps = {
  description: '',
  disabled: false,
};

export default SwitchRow;
